// extracted by mini-css-extract-plugin
module.exports = {"domainSettings":"styles_domainSettings__1oQgx"};